
import { supabase } from "./supabaseClient";

// NOTE: document extraction now happens via a copy-prompt + JSON-import + the
// `bulk-insert-data` edge function (see DataInputView / publicDataService). The old
// `extract-document-data` invoker was removed along with that deleted function.

export const validateSurveyResponse = async (question: string, answer: string, validationPrompt?: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('validate-survey-response', {
      body: {
        question,
        answer,
        validationPrompt
      }
    });

    if (error) throw error;

    return {
      ...data,
      isValid: (data.score || 0) >= 7
    };
  } catch (error) {
    console.error("Gemini Validation Service Error:", error);
    return { isValid: true, feedback: "" };
  }
};

export const generateSurveySchema = async (topic: string, context?: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('generate-survey-schema', {
      body: {
        topic,
        context
      }
    });

    if (error) throw error;

    return data;
  } catch (error) {
    console.error("Gemini Survey Gen Service Error:", error);
    throw error;
  }
};
